import React, { Component } from "react";
import { lastFriday } from "./utils";

class RewardFooter extends Component {
  state = {
    rewardStartDate: lastFriday(),
  };

  render() {
    let { rewardStartDate } = this.state;
    let { foods } = this.props;

    const rewardStartTimestamp = new Date(rewardStartDate).getTime();
    const answers_since_date = Object.keys(foods)
      .map(key => foods[key])
      .filter(food => food.updatedAt >= rewardStartTimestamp).length;

    window.foods = foods;
    console.log({ answers_since_date });

    const reward = answers_since_date * 0.25;

    return (
      <div
        className="input-group"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <span className="input-group-addon">Answers since</span>
        <input
          type="date"
          className="form-control"
          value={rewardStartDate}
          onChange={e => this.setState({ rewardStartDate: e.target.value })}
        />
        <span className="input-group-addon">
          = {answers_since_date} (${reward})
        </span>
      </div>
    );
  }
}

export default RewardFooter;



/** WEBPACK FOOTER **
 ** ./src/RewardFooter.js
 **/